<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-22 10:58:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-10-31 11:47:16
 * @FilePath: 
 * @Description: 支付方式组件
-->
<template>
  <van-radio-group class="pay_radios_con" v-model="payType">
    <van-cell-group>
      <van-cell
        title="本人手牌挂账"
        clickable
        v-if="!isTableLedger"
        @click="payType = 1"
      >
        <template #extra>
          <van-radio :name="1">
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
        </template>
        <template #right-icon>
          <p
            v-if="!cardCode"
            style="color: #52c41a"
            class="pay_desc_con"
            @click="handleBindCard"
          >
            绑手牌
          </p>
          <p v-else class="pay_desc_con c-lightgrey">
            手牌号<span class="c-main-txt m-lr-10">{{ cardCode }}</span>
          </p>
        </template>
      </van-cell>

      <div v-else>
        <van-cell
          v-if="fromPage != 'pop' && isPayAfterMeal"
          title="餐后付"
          clickable
          @click="payType = 4"
        >
          <template #extra>
            <van-radio :name="4">
              <template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                />
              </template>
            </van-radio>
          </template>
        </van-cell>
        <van-cell
          title="立即支付"
          v-if="isTableLedger"
          clickable
          @click="payType = 2"
        >
          <template #right-icon>
            <p class="c-lightgrey pay_desc_con">在线支付</p>
          </template>
          <template #extra>
            <van-radio :name="2">
              <template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                />
              </template>
            </van-radio>
          </template>
        </van-cell>

        <!-- <van-cell title="他人代付" clickable @click="payType = 3">
        <template #extra>
          <van-radio :name="3">
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
        </template>
      </van-cell> -->
      </div>
    </van-cell-group>
  </van-radio-group>
</template>

<script>
import { handleSessionStorage, handleScanCode } from "@/utils";
import { getScanTakeNumber } from "@/api/scan";
export default {
  name: "GoodsListCard",
  props: {
    // payType: {
    //   type: String,
    //   default: "3",
    // },
    fromPage: {
      //用于判断是否展示餐后付
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cardCode: null,
      payType: 1,
      activeIcon: require("@/assets/radio/radio-active.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive.png"),
      isTableLedger: true,
    };
  },
  created() {
    const vpnInfo = handleSessionStorage.get("vpnInfo");
    this.isPayAfterMeal = vpnInfo.PayAfterMeal;
    this.isTableLedger = vpnInfo.TableLedger;
    this.vpnCode = vpnInfo.code;
    this.payType = this.isTableLedger ? 2 : 1;
    const deskInfo = handleSessionStorage.get("deskCode");
    this.cardCode = deskInfo ? deskInfo.cardCode : "";
  },
  methods: {
    handleBindCard() {
      // this.$emit("sweepCode", type);
      // 调起微信扫码，
      handleScanCode({ needResult: 1 }, (res) => {
        const cardCodeData = res.resultStr;
        if (!cardCodeData) {
          this.$toast("二维码为空，请确认后重新扫码");
          return;
        }
        const queryArr = cardCodeData.split("?");
        const queryStr = queryArr[queryArr.length - 1]; //uuid=xxx&vpncode=xxx
        const uuidQuery = this.getQueryVariable(queryStr, "uuid");
        const vpncodeQuery = this.getQueryVariable(queryStr, "vpncode");
        const vpnIdQuery = this.getQueryVariable(queryStr, "v"); //直接扫手牌码模式时的门店id
        const cardCodeQuery = this.getQueryVariable(queryStr, "c"); //直接扫手牌码模式时的手牌号
        if ((!uuidQuery || !vpncodeQuery) && (!vpnIdQuery || !cardCodeQuery)) {
          this.$toast("二维码缺少必要参数，请确认后重新扫码");
          return;
        }
        if (vpncodeQuery && vpncodeQuery !== this.vpnCode) {
          this.$toast("二维码中门店与点餐门店不一致，请确认后重新扫码");
          return;
        }
        let queryData = {
          IsBind: true,
        };
        if (vpnIdQuery) {
          queryData.VpnId = vpnIdQuery;
          queryData.TableCode = cardCodeQuery;
        } else if (uuidQuery) {
          queryData.BindingUuid = uuidQuery;
          queryData.VpnCode = vpncodeQuery;
        }

        getScanTakeNumber(queryData)
          .then((res) => {
            // const res = {
            //   TableCode: 8001,
            //   CheckinId: "9d6499fc-015e-4f57-9e51-2e1e29f7faad",
            // };
            this.$toast("绑定成功");
            this.cardCode = res.TableCode;
            const deskObj = handleSessionStorage.get("deskCode");
            handleSessionStorage.set("deskCode", {
              ...deskObj,
              checkinId: res.CheckinId,
              cardCode: res.TableCode,
            });
            this.$emit("handleResetCardInfo");
          })
          .catch((err) => {});
      });
    },
    getQueryVariable(url, variable) {
      const vars = url.split("&");
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.pay_radios_con {
  .pay_desc_con {
    width: 170px;
  }
  .van-radio {
    margin-right: 8px;
  }
  .img-icon {
    width: 30px;
  }
}
</style>
